import { HttpClient } from "@angular/common/http";
import { Reference } from "@angular/compiler/src/render3/r3_ast";
import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { ObserveOnSubscriber } from "rxjs/internal/operators/observeOn";
import { Page } from "src/app/util/page";
import { Invoice } from "../invoice/invoice";
import { PurchaseOrder } from "./purchase-order";
import { PurchaseOrderDetail } from "./purchase-order-detail";
import { PurchaseOrderSearchResult } from "./purchase-order-search-result";
import { SearchRequest } from "./search-request";

@Injectable()
export class PurchaseOrderService {
  constructor(private httpClient: HttpClient) { }

  public cancel(number: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/purchase/order/${number}`);
  }

  public create(supplierId: string): Observable<PurchaseOrder> {
    return this.httpClient.post<PurchaseOrder>(`/api/purchase/order?supplierId=${supplierId}`, {});
  }

  public findByNumber(number: number): Observable<PurchaseOrder> {
    return this.httpClient.get<PurchaseOrder>(`/api/purchase/order/${number}`);
  }

  public findInvoices(number: number): Observable<Invoice[]> {
    return this.httpClient.get<Invoice[]>(`/api/purchase/order/${number}/invoice`);
  }

  public getNeedaFileByType(purchaseOrderNumber: number, type: string): Observable<string> {
    return this.httpClient.get(`/api/purchase/order/${purchaseOrderNumber}/needa/${type}`, { responseType: "text" });
  }

  public removeDetail(number: number, reference: string): Observable<void> {
    return this.httpClient.delete<void>(`/api/purchase/order/${number}/${reference}`);
  }

  public search(searchRequest: SearchRequest, page: number, size: number): Observable<Page<PurchaseOrderSearchResult>> {
    return this.httpClient.post<Page<PurchaseOrderSearchResult>>(
      `/api/purchase/order?search&page=${page}&size=${size}&sort=number,DESC`,
      searchRequest,
    );
  }

  public submit(number: number): Observable<void> {
    return this.httpClient.post<void>(`/api/purchase/order/${number}?submit`, null);
  }

  public updateDeliveryMode(deliveryMode: string, number: number): Observable<void> {
    return this.httpClient.put<void>(`/api/purchase/order/${number}?deliveryMode=${deliveryMode}`, null);
  }

  public updateQuantity(number: number, reference: string, quantity: number): Observable<void> {
    return this.httpClient.put<void>(`/api/purchase/order/${number}/${reference}?quantity=${quantity}`, null);
  }
}